import type { CluePayload } from '@guess/engine';
import type { ClueProps } from './ClueRenderer';
import s from './clue.module.scss';

type EmojiPayload = Extract<CluePayload, { kind: 'emoji' }>;

/**
 * La suite d'emojis, qui s'allonge palier par palier.
 *
 * Le decoupage passe par `Intl.Segmenter` quand il existe : un emoji compose
 * (famille, drapeau, couleur de peau) est plusieurs points de code, et un
 * `[...chaine]` le couperait en morceaux illisibles. Le repli naif ne casse
 * que les emojis composes, et seulement sur de vieux navigateurs.
 */
function graphemes(text: string): string[] {
  const Segmenter = Intl.Segmenter;
  if (typeof Segmenter === 'function') {
    return [...new Segmenter('fr', { granularity: 'grapheme' }).segment(text)].map((g) => g.segment);
  }
  return [...text];
}

export function EmojiClue({ payload, stageToken }: ClueProps<EmojiPayload>) {
  const glyphs = graphemes(payload.sequence);

  return (
    <p className={s.emojiRow} aria-label={`Indice en emojis : ${payload.sequence}`}>
      {glyphs.map((glyph, index) => (
        <span
          // La cle porte le palier : le dernier emoji rejoue son arrivee a
          // chaque allongement, les precedents restent immobiles.
          key={`${stageToken}-${index}`}
          className={s.emoji}
          // Un decalage par rang fait tomber la serie en cascade au premier
          // palier, puis n'anime plus que l'ajout.
          style={{ animationDelay: `calc(var(--dur-fast) * ${index})` }}
        >
          {glyph}
        </span>
      ))}
    </p>
  );
}
